import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {LibraryEntry} from '../../models';

@Component({
    standalone: false,
    selector: 'app-item-quantification-tab',
    templateUrl: './item-quantification-tab.component.html'
})
export class ItemQuantificationTabComponent {
    @Input() entry: LibraryEntry;
    @Input() libraryType: string;
    @Input() formGroup: FormGroup;

    constructor() {
    }
}
